<div class="del_popup_box pmntSucesPopUp">
    <form >
        <div class="popUpInner">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                    <div class="text-center">
                        <p class="popHeading">Thank you</p>
                        <p class="popDesc">You have successfully registered students for the HHSQ examination 2024-25</p>
                    </div>
                </div>
                <div class="col-lg-12 text-center d-flex justify-content-center">
                    <div class="pop_img_div">
                        <img src="assets/img/tick.png" class="delete_img" alt="">
                    </div>
                </div>
                <div class="col-lg-12 text-center my-4">
                    <p class="pmntText">Payment Successful!</p>
                </div>
                <div class="col-lg-12 text-center">
                    <button type="button" class="btn_theme" data-dismiss="modal" (click)="closeModal()">Close</button>
                </div>
            </div>
        </div>
    </form>
</div>